module.exports = __webpack_public_path__ + "static/img/20.7e8f1e9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/4/eng/20.png
// module id = tmt8
// module chunks = 0